import { ApiService } from 'services/api.service';
import { Component, OnInit } from '@angular/core';
import { MetaDataDto } from "dto/MetadataDto";

@Component({
  selector: 'toolbox',
  templateUrl: './toolbox.component.html',
  styleUrls: ['./toolbox.component.css']
})
export class ToolboxComponent implements OnInit {

  templates:MetaDataDto[];
  constructor(private apiService:ApiService) { }

  ngOnInit() {
    this.apiService.loadExpressionTemplates().subscribe((result)=>this.templates = result);
  }

}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/toolbox/toolbox.component.ts